import { ITEM_TYPES, SCORING } from '../config.js';
import { isStreamLead } from './leadScoring.js';

/**
 * Applies score/lives/stats for a hit without removing the item from the board.
 * @param {object} state
 * @param {object} item
 */
export function applyItemHitEffects(state, item) {
    const next = {
        ...state,
        breakdown: { ...state.breakdown },
        stats: { ...state.stats },
        items: state.items,
    };

    switch (item.type) {
        case ITEM_TYPES.GOOD_LEAD:
        case ITEM_TYPES.HOT_LEAD: {
            if (isStreamLead(item)) {
                next.score += SCORING.STREAM_LEAD;
                next.breakdown.leads = (next.breakdown.leads || 0) + SCORING.STREAM_LEAD;
                next.stats.leadsCaught = (next.stats.leadsCaught || 0) + 1;
                break;
            }

            if (item.type === ITEM_TYPES.HOT_LEAD) {
                next.score += SCORING.HOT_LEAD;
                next.breakdown.hotLeads += SCORING.HOT_LEAD;
                next.stats.hotHits += 1;
            } else {
                next.score += SCORING.GOOD_LEAD;
                next.breakdown.goodLeads += SCORING.GOOD_LEAD;
                next.stats.goodHits += 1;
            }
            break;
        }

        case ITEM_TYPES.BONUS:
            next.score += SCORING.BONUS;
            next.breakdown.bonus += SCORING.BONUS;
            next.stats.bonusHits += 1;
            break;

        case ITEM_TYPES.ACTIVITY_ITEM:
            next.score += SCORING.ACTIVITY_ITEM;
            next.breakdown.activities += SCORING.ACTIVITY_ITEM;
            next.stats.activityHits += 1;
            break;

        case ITEM_TYPES.BAD_ITEM:
            next.score = Math.max(0, next.score - SCORING.BAD_ITEM);
            next.lives = Math.max(0, next.lives - 1);
            next.breakdown.penalties += SCORING.BAD_ITEM;
            next.stats.badHits += 1;
            break;

        default:
            break;
    }

    return next;
}

export function applyItemHit(state, item) {
    const next = applyItemHitEffects(state, item);
    return {
        ...next,
        items: next.items.filter((candidate) => candidate.id !== item.id),
    };
}

export function expireItems(state, nowMs) {
    let missedGoodLeads = 0;

    const remainingItems = state.items.filter((item) => {
        const expired = item.expiresAt <= nowMs;
        if (expired && isStreamLead(item)) {
            missedGoodLeads += 1;
        }
        return !expired;
    });

    if (!missedGoodLeads && remainingItems.length === state.items.length) {
        return state;
    }

    return {
        ...state,
        items: remainingItems,
        stats: {
            ...state.stats,
            missedGoodLeads: state.stats.missedGoodLeads + missedGoodLeads,
        },
    };
}
